import { EMPTY_AVATAR_SRC } from 'constants/user';
import { getImageOrPlaceholder } from './getImageOrPlaceholder';

interface ImageDetails {
  path: string | null | undefined;
  placeholder?: string | null | undefined;
}

export const getProfileImageUrlOrPlaceholder = ({ path, placeholder }: ImageDetails) => {
  return getImageOrPlaceholder({ path: path, placeholder: placeholder || EMPTY_AVATAR_SRC });
};
